<div class="v-one-carousel__container">
  <div class="v-one-carousel__content">
    @for (slide of slides(); track slide.imageUrl; let i = $index) {
      <div
        class="v-one-carousel__slide"
        [class.v-one-carousel__slide--active]="i === activeSlideIndex()"
      >
        <div class="v-one-carousel__slide-image">
          <img
            class="v-one-carousel__image"
            [src]="getImageUrl(slide.imageUrl)"
            [alt]="
              slide.altText || 'global.carousel.slides.image.altText'
                | translate
            "
            (error)="onImageError($event)"
          />
        </div>
      </div>
    }
  </div>

  @if (showIndicators() && slides().length > 1) {
    <div class="v-one-carousel__indicators">
      @for (slide of slides(); track slide.imageUrl; let i = $index) {
        <button
          class="v-one-carousel__indicator"
          [class.v-one-carousel__indicator--active]="i === activeSlideIndex()"
          (click)="setActiveSlide(i)"
          [attr.aria-label]="'Slide ' + (i + 1)"
        >
          <span class="sr-only d-none"
            >{{ 'global.carousel.indicators.button.text' | translate }}
            {{ i + 1 }}</span
          >
        </button>
      }
    </div>
  }
</div>
